import AuthenticationLoader from './AuthenticationLoader'; // eslint-disable-line import/no-cycle

export default AuthenticationLoader;
